export const USER_CONFIG_KEY_BASE = 'user_config';
export const GUEST_KEY = 'user_config';
export const UserConfigKeyFactory = {
    all: () => [USER_CONFIG_KEY_BASE],
    byEmail: (email) => [
        ...UserConfigKeyFactory.all(),
        email,
    ],
    byEmailAndWorkspaceName: (email, workspaceName) => [...UserConfigKeyFactory.all(), email, workspaceName],
    byEmailGuest: (email, identifier) => [
        ...UserConfigKeyFactory.all(),
        GUEST_KEY,
        email,
        identifier,
    ],
};
